import React from 'react';
import { makeStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Theme } from '@mui/material/styles';

import styles from 'assets/jss/material-kit-react/components/customInputStyle.js';

const useStyles = makeStyles<Theme>(styles);

export interface CustomSelectProps {
  labelText: string;
  id: string;
  // MUI Select expects value to be string or undefined
  value: string | undefined;
  onChange: (event: SelectChangeEvent) => void;
  children: React.ReactNode;
  formControlProps?: any;
  labelProps?: any;
  error?: boolean;
  success?: boolean;
  disabled?: boolean;
}

export function CustomSelect({
  labelText,
  id,
  value,
  onChange,
  children,
  formControlProps,
  labelProps,
  error,
  success,
  disabled,
}: CustomSelectProps) {
  const classes = useStyles();

  return (
    <FormControl {...formControlProps} className={classes.formControl} disabled={disabled}>
      <InputLabel
        htmlFor={id}
        className={[
          classes.labelRoot,
          error ? classes.labelRootError : '',
          success && !error ? classes.labelRootSuccess : '',
        ].join(' ')}
        {...labelProps}
      >
        {labelText}
      </InputLabel>
      <Select
        labelId={id}
        id={id}
        value={value}
        onChange={onChange}
        label={labelText}
        variant="outlined"
        size="small"
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.5) !important',
              borderWidth: '1px !important',
            },
            '&:hover fieldset': {
              borderColor: '#FFD700 !important',
              borderWidth: '1px !important',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#FFD700 !important',
              borderWidth: '2px !important',
            },
          },
          '& .MuiInputLabel-root': {
            '&.Mui-focused': {
              color: '#FFD700 !important',
            },
          },
        }}
        disabled={disabled}
      >
        {children}
      </Select>
    </FormControl>
  );
}
